const API_KEY = '9973533'; // PERSONAL API_KEY FROM PATREON
const DRINK_ID = '17005';
export const API_URL = `https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=${DRINK_ID}`;